__turbopack_context__.v({
  "imageContainer": "styles-module-scss-module__FIXquW__imageContainer",
  "pageFooter": "styles-module-scss-module__FIXquW__pageFooter",
  "text": "styles-module-scss-module__FIXquW__text",
  "textContainer": "styles-module-scss-module__FIXquW__textContainer",
});
